export default __webpack_public_path__ + "static/media/Yvette_Bodden_AHV_In_Moms_We_Trust.b282da3c.jpg";